import {useEffect, useState} from 'react';
import type {SwiperClass} from 'swiper/react';

export const useHasVisibleArrows = (swiper: SwiperClass) => {
  const [hasVisibleArrows, setHasVisibleArrows] = useState(false);

  useEffect(() => {
    const prevEl = swiper?.navigation?.prevEl;
    const nextEl = swiper?.navigation?.nextEl;
    if (!prevEl || !nextEl) {
      return;
    }
    const isVisible = (el: HTMLElement) => {
      /* istanbul ignore next */
      const computedStyle = getComputedStyle(Array.isArray(el) ? el[0] : el);
      return computedStyle.display !== 'none';
    };
    setHasVisibleArrows(isVisible(prevEl) || isVisible(nextEl));
  }, [swiper]);

  return hasVisibleArrows;
};
